module.exports = __webpack_public_path__ + "img/A-6179298-1513026522-8174.jpeg.c10c49fe.jpg";